import { useTranslation } from "react-i18next";
import Loader from "./common/Loader";
import Layout from "./common/Layout";

const LoaderPage = () => {
  const { t } = useTranslation();

  return (
    <>
      <Layout>
        <Loader
          loading={true}
          title={t("initial.loader.title")}
          message={t("initial.loader.desc")}
        />
      </Layout>
    </>
  );
};

export default LoaderPage;
